<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    right1Data: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      chart.init(props.right1Data);
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init(rightDataLine) {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

    this.state.chart.setOption({
      grid: {
        top: "26%",
        left: "10%",
        right: "5%",
        bottom: "15%",
      },
      title: {
        text: "万",
        left: "left", // 文本水平居中
        top: 0, // 距离顶部10像素
        textAlign: "left", // 文本左对齐
        textStyle: {
          color: "rgba(255,255,255,.65)",
          fontSize: 25,
        },
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        axisLine: {
          show: true,
          onZero: false,
          lineStyle: {
            color: "#024349",
          },
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: "rgba(255,255,255,.65)",
            fontSize: 26,
          },
        },
        data: [ "2019", "2020", "2021", "2022",'2023'],
      },
      yAxis: {
        type: "value",
         min: 0, // 刻度最小值
        max: 5000, // 刻度最大值（需要动态获取最大值,并且能被3整除（向下取整再乘回来））
        splitNumber: 4, // 横线数
        interval: 2500, 
        axisLabel: {
          show: true,
          formatter: function(value) {
            // 当值为 0 时不显示标签
            return value === 0 ? '' : value;
          },
          textStyle: {
            color: "rgba(255,255,255,.65)",
            fontSize: 24,
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#35414D",
            type: [5, 10],
            dashOffset: 5,
          },
        },
      },
      series: [
        {
          data: [1810, 1904, 3179, 3247, 3995],
          type: "line",
          smooth: true,
          symbolSize: 0.01,
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 0.9, [
              {
                offset: 0,
                color: "rgba(227, 189 ,90,0)",
              },
              {
                offset: 1,
                color: "rgba(227, 189 ,90,0)",
              },
              {
                offset: 0,
                color: "rgba(227, 189 ,90,.5)",
              },
            ]),
          },
          itemStyle: {
            color: "#E3BD5A",
          },
          lineStyle: {
            // 线条加阴影
            // 设置阴影颜色
            // shadowColor: "#3D5DF4",
            shadowColor: "#E3BD5A",
            shadowOffsetX: 0,
            // 设置阴影沿y轴偏移量为9
            shadowOffsetY: 9,
            // 设置阴影的模糊大小
            shadowBlur: 20,
            // 设置线条渐变色
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
              { offset: 0, color: "#E3BD5A" },
              // { offset: 0.2, color: "#3D5DF4" },
              { offset: 0.2, color: "#E3BD5A" },
              { offset: 0.1, color: "#E3BD5A" },
            ]),
          },

          emphasis: {
            scale: 1000,
            itemStyle: {
              color: "#3D5DF4",
              borderColor: "#FFFFFF",
              borderWidth: 3,
              borderType: "solid",
            },
          },
        },
      ],
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
